import { NavLink } from 'react-router-dom';
import Scrollspy from 'react-scrollspy';
import { useState, useEffect } from 'react';
const SideBar = ({
  title,
  side_list,
  parent_link,
  isSubMenuAttached,
  isOnePage,
  side_scroll_color,
}) => {
  const [isViewportlg, setIsViewPortLg] = useState();
  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);
  const onResize = () => {
    // setIsViewPortLg();
    // console.log(window.innerWidth);
    if (window.innerWidth >= 1000) {
      setIsViewPortLg(true);
    } else {
      setIsViewPortLg(false);
    }
  };
  let item_list = [];
  for (let item in side_list) {
    item_list.push(side_list[item][0]);
  }
  if (isOnePage)
    //scrollspy 있는 경우
    return (
      <ul
        className="d-none d-lg-block"
        style={{
          position: `${isSubMenuAttached ? 'fixed' : 'absolute'}`,
          top: `${isSubMenuAttached ? '2rem' : '19.8rem'}`,
          left: '0',
          listStyle: 'none',
          color: '#a0a0a0',
          width: '17rem',
        }}
      >
        <h3
          style={{
            color: `${
              side_scroll_color === undefined
                ? 'white'
                : side_scroll_color.color
            }`,
            backgroundColor: `${
              side_scroll_color === undefined
                ? '#E40613'
                : side_scroll_color.bg_color
            }`,
            padding: '5rem 1rem 1rem 1rem',
            marginTop: '0',
            borderTopLeftRadius: '0.2rem',
            borderTopRightRadius: '0.2rem',
          }}
        >
          {title}
        </h3>
        <Scrollspy
          items={item_list}
          currentClassName="current"
          style={{ paddingLeft: '0' }}
        >
          {side_list.map((element, key) => {
            return (
              <li key={key} style={{ listStyle: 'none' }}>
                <a
                  href={`/${parent_link}/#${element[0]}`}
                  style={{
                    color: '#A0A0A0',
                    fontSize: '1.1rem',
                    display: 'block',
                  }}
                  className="p-2"
                >
                  {element[1]}
                </a>
              </li>
            );
          })}
        </Scrollspy>
      </ul>
    );
  return (
    // 이하의 주석은 fixed sidebar
    // <ul
    //   className="list-group position-fixed"
    //   style={{ listStyle: 'none', top: '30rem', left: '2vw' }}
    // >
    <ul
      style={{
        position: `${isSubMenuAttached ? 'fixed' : 'absolute'}`,
        top: `${isSubMenuAttached ? '2rem' : '19.8rem'}`,
        left: '0',
        listStyle: 'none',
        width: '16rem',
        // width: `${isViewportlg ? '17rem' : '10rem'}`,
        // paddingLeft: `${isViewportlg ? '32px' : '0px'}`,
      }}
      className="d-none d-lg-block"
    >
      <h3
        style={{
          color: `${
            side_scroll_color === undefined ? 'white' : side_scroll_color.color
          }`,
          backgroundColor: `${
            side_scroll_color === undefined
              ? '#E40613'
              : side_scroll_color.bg_color
          }`,
          // padding: `${isViewportlg}:'5rem 1rem 1rem 1rem':'5rem 0rem 0rem 0rem'`,
          padding: '5rem 1rem 1rem 1rem',
          marginTop: '0',
          borderTopLeftRadius: '0.2rem',
          borderTopRightRadius: '0.2rem',
        }}
      >
        {title}
      </h3>
      {side_list.map((element, key) => {
        return (
          <li key={key}>
            <NavLink
              key={key}
              exact
              to={`/${parent_link}/${element[0]}`}
              style={{
                color: '#A0A0A0',
                fontSize: '1.1rem',
                display: 'block',
              }}
              activeClassName="toc-active"
              className="p-2"
            >
              {element[1]}
            </NavLink>
          </li>
        );
      })}
    </ul>
  );
};
export default SideBar;
